// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"146":"319b33b5","252":"4cf932c0","354":"4ff67c2d","482":"73845f7d","542":"319b33b5"}[chunkId] + ".chunk.css";
};